import Layout from "../../Containers/Layout";
import {  useState } from "react";
import styles from "./DisciplineGroups.module.scss";
import { Button, Modal, Table, TablePaginationConfig, Tag, Tooltip, Typography } from "antd";
import Search from 'antd/lib/input/Search';
import { useQuery, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PlusOutlined } from "@ant-design/icons";
import { Link, useParams  } from "react-router-dom";
import { theme } from "../../theme";
import { NOTIFICATION_TYPES, openNotification } from "../Notifications/NotificationsUtils";
import { assignSubjectsToGroup, deleteDisciplineGroup, getDisciplineGroups, getSubjectsForGroup } from "../../Requests/discipline-group-requests";
import { DisciplineGroup, DisciplineGroupTypeEnum, SubjectRequestType, SubjectsForGroupDTO } from "../../Api";
import { SubjectMultiSelectModal } from "./SubjectMultiSelectModal";
import { getStudyPlanById } from "../../Requests/study-plan-requests";

interface PageResponse<T> {
    data?: T[] | null,
    totalCount?: number,
    page?: number,
    pageSize?: number
}

type SubjectOption = { value: string; label: string };

type SubjectsModalState = {
  open: boolean;
  title: string;
  groupId?: string;
  initialSelectedIds: string[];
  options: SubjectOption[];
  loading: boolean;
};

export type PageCallBack<T> = (currentPage: number, pageSize: number) => Promise<PageResponse<T> | null | undefined>;
export type ColumnType<T> = { title: string, key: any, dataIndex?: string, width?: any, render?: (text: string, record: T, index: number) => any };

const DisciplineGroups = () => {
    const { t } = useTranslation();  
    const { studyPlanId } = useParams<{ studyPlanId: string }>();
    const [searchTermName, setSearchTermName] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrent] = useState(1);
    const [currentGroup, setCurrentGroup] = useState<any | null>(null);
    
    const [subjectsModal, setSubjectsModal] = useState<SubjectsModalState>({
    open: false,
    title: '',
    groupId: undefined,
    initialSelectedIds: [],
    options: [],
    loading: false,
    });
    
    const [modalPropsDelete, setModalPropsDelete] = useState({
        isModalVisible: false,
        title: '',
        id: '',
    });

    const [modalProps, setModalProps] = useState<{ isModalVisible: boolean, title: string, data: string[]}>({
        isModalVisible: false,
        title: '',
        data: []
    });

    const handleClose = () => {
        setModalProps(modalProps => ({...modalProps, isModalVisible: false}));
    }

    const handleOk = () => {
        setModalProps(modalProps => ({...modalProps, isModalVisible: false}));

    }

    const handleShowDelete = (id: string) => {
        setModalPropsDelete(modalProps => ({...modalProps, isModalVisible: true, id}));
    }

    const handleCloseDelete = () => {
        setModalPropsDelete(modalProps => ({...modalProps, isModalVisible: false}));
    }

    const handleOkDelete = () => {
        setModalPropsDelete(modalProps => ({...modalProps, isModalVisible: false}));
        deleteDisciplineGroup(modalPropsDelete.id)
            .then(() => {
                deleteSucceded();
                invalidateQuery();
            })
            .catch(deleteFailed);

    }
  
    const handleTableChange = (pagination: TablePaginationConfig) => {
        setCurrent(() => pagination.current ?? 1);
        setPageSize(() => pagination.pageSize ?? 10);
    };

    const deleteSucceded = () => {
        openNotification(
            'Succes',
            'Ștergerea s-a realizat cu succes!',
            NOTIFICATION_TYPES.SUCCESS
        );
    };

    const deleteFailed = (_err: any) => {
        openNotification(
            'Eroare',
            'Ștergerea nu s-a realizat cu succes!',
            NOTIFICATION_TYPES.ERROR
        );
    };

    const queryClient = useQueryClient();

    const invalidateQuery = () => { queryClient.invalidateQueries('getDisciplineGroups') };

    const openFetchError = (_error: any) => {
        openNotification(
            'Eroare!',
            'Datele nu au putut fi aduse din server!',
            NOTIFICATION_TYPES.ERROR
        );
    }

    const { data, isLoading } = useQuery(['getDisciplineGroups', searchTermName, pageSize, currentPage],
        () => {
            return getDisciplineGroups(studyPlanId, searchTermName, undefined, undefined, currentPage, pageSize);
        },
        {
            onError: openFetchError,
        }
    );

    const { data: studyPlan } = useQuery(['getstudyPlan', studyPlanId],
        () => {
            return getStudyPlanById(studyPlanId);
        },
        {
            onError: openFetchError,
        }
    );

    const studyPlanCycle = studyPlan?.studyCycle || '';

    const FilterByNameInput = (
        <Search placeholder={t('account.name')} allowClear onSearch={setSearchTermName} style={{ width: '100%' }} />
    );

     const FilterByStudyYearInput = (
        <div>
            <label>An Studiu</label>
            {/* <Select defaultValue={filters.programLanguageOption} style={{ width: "180px" }} 
                onChange={(searchTermLanguage) => {
                    handleTablePageChange(1, filters.pageSize)
                    setFilters({...filters, programLanguageOption: searchTermLanguage})}}
                options={getLanguageOptions()}>
            </Select> */}
        </div>
    );

    const FilterBySemesterInput = (
        <div>
            <label>Semestru</label>
            {/* <Select defaultValue={filters.programLanguageOption} style={{ width: "180px" }} 
                onChange={(searchTermLanguage) => {
                    handleTablePageChange(1, filters.pageSize)
                    setFilters({...filters, programLanguageOption: searchTermLanguage})}}
                options={getLanguageOptions()}>
            </Select> */}
        </div>
    );

    const closeSubjectsModal = () => {
        setSubjectsModal(prev => ({ ...prev, open: false }));
    };

    const openSubjectsModalForGroup = async (group: any) => {
        
        setCurrentGroup(group);
        
        const initialSelectedIds = (group?.subjects ?? []).map((s: any) => String(s.id));

        setSubjectsModal(prev => ({
            ...prev,
            open: true,
            title: `Asignează discipline — ${group?.name ?? ''}`,
            groupId: group?.id,
            initialSelectedIds,
            loading: true,
        }));

        try {
            const disciplines: SubjectsForGroupDTO[] = await getSubjectsForGroup(
                group?.semester!,
                group?.studyYear!,
                studyPlanId,
                SubjectRequestType.ForGroups,
                undefined,             
                group.id,
            );

            const options: SubjectOption[] = disciplines.map((s: any) => ({
                value: String(s.id),
                label: s.nameRO,
            }));

            setSubjectsModal(prev => ({ ...prev, options, loading: false }));
        } catch {
            setSubjectsModal(prev => ({ ...prev, loading: false }));
        }

    

    };

    const handleAssignSubjects = async (subjectIds: string[]) => {
        console.log("group", currentGroup);
        
        if (!currentGroup?.id) return;

        try {
            await assignSubjectsToGroup(currentGroup.id, subjectIds);

            openNotification("Succes", "Disiciplinele au fost adaugate.", NOTIFICATION_TYPES.SUCCESS);
            invalidateQuery();      
            closeSubjectsModal();    
        } catch (err: any) {
            openNotification("Eroare", err?.message ?? "Nu s-au putut adauga disciplinele.", NOTIFICATION_TYPES.ERROR);
        }
    }; 

    const columns = [
        {
            title: FilterByNameInput,
            dataIndex: 'completeName',
            render: (text: string, record: any, index: number) => {
                return record.name;
            }
        },
        {
            title: 'Tip Grup',
            width: '150px',
            render: (text: string, record: DisciplineGroup, index: number) =>
                  record.type === DisciplineGroupTypeEnum.DisciplineGroup ? <Tag color='magenta'  key={DisciplineGroupTypeEnum.DisciplineGroup}>Grup Discipline</Tag>
                : record.type === DisciplineGroupTypeEnum.PackGroup ? <Tag color='gold'  key={DisciplineGroupTypeEnum.PackGroup}>Grup Pachete</Tag>
                : 'N/A'
        },
        {
            title: 'Nr. discipline',
            width: '110px',
            dataIndex: 'disiplineCount',
            key: 'disiplineCount',
        },
         {
            title: FilterByStudyYearInput,
            width: '200px',
            dataIndex: 'studyYear',
            render: (text: string, record: any, index: number) => {
                return record.studyYear;
            }
        },
         {
            title: FilterBySemesterInput,
            width: '200px',
            dataIndex: 'semester',
            render: (text: string, record: any, index: number) => {
                return record.semester;
            }
        },
        {
            title: "Discipline/ Subgrupuri",
            width: '160px',
            render: (_: string, record: DisciplineGroup) => {
                const isDisciplineGroup = record.type === DisciplineGroupTypeEnum.DisciplineGroup;
                return (
                <div>
                    {isDisciplineGroup ? (
                    <Tooltip title='Asignează discipline' >
                        <FontAwesomeIcon onClick={() => openSubjectsModalForGroup(record)} icon={solid('edit')} style={{ cursor: 'pointer', height: "1rem", padding: "6px 0px" }}/>
                    </Tooltip>
                    ) : (
                    <Tooltip title='Administrează subgrupuri'>
                        <Link to={"/discipline-groups/" + record.id + "/subgroups"}>
                            <FontAwesomeIcon icon={solid('edit')} style={{ cursor: 'pointer', height: "1rem", padding: "6px 0px" }}/>
                        </Link>
                    </Tooltip>
                    
                    )}
                </div>
                );
            }
        },
        {
            title: 'Acțiuni',
            width: '100px',
            render: (text: string, record: any, index: number) => 
                <div>
                    <Link to={{pathname: "/editare-grup/" + record.id, state: {studyPlanId, studyPlanCycle}}} ><Tooltip title='Editare'>
                        <FontAwesomeIcon icon={solid('edit')} style={{ cursor: 'pointer', height: "1rem", padding: "6px 0px" }}/>
                    </Tooltip></Link>
                    <Tooltip title='Ștergere'>
                        <FontAwesomeIcon icon={solid('trash')} style={{ marginLeft: '20px', cursor: 'pointer', height: "1rem", padding: "6px 0px" }}
                        onClick={() => handleShowDelete(record.id)}/>
                    </Tooltip>
                </div>
        }
    ];

    return    <div className={styles.container} style={{ display: "flex", flexDirection: "column", marginTop: "0%" }}>
        <Layout>
            <Modal
                open={modalPropsDelete.isModalVisible}
                onOk={handleOkDelete}
                onCancel={handleCloseDelete}
                title="Ștergere"
                width={"400px"}
                okText={t('account.confirm')}
                cancelText={t('account.cancel')}
                cancelButtonProps={{ style: { background: theme.green, border: theme.green, color: theme.white, borderRadius: "10px" } }}
                okButtonProps={{ style: { background: theme.secondColor, border: theme.secondColor, borderRadius: "10px" } }}
                >
                    <div>
                        <Typography>Sigur doriti stergerea grupului?</Typography>
                    </div>
            </Modal>
            <Modal
                open={modalProps.isModalVisible}
                onOk={handleOk}
                onCancel={handleClose}
                title={modalProps.title}
                width={"500px"}
                okText={t('account.confirm')}
                cancelText={t('account.cancel')}
                cancelButtonProps={{ style: { background: theme.green, border: theme.green, color: theme.white, borderRadius: "10px" } }}
                okButtonProps={{ style: { background: theme.secondColor, border: theme.secondColor, borderRadius: "10px" } }}
                >
                    <div>
                        {modalProps.data.map(name => <Typography key={name}>- {name}</Typography>)}
                    </div>
            </Modal>

            <SubjectMultiSelectModal
                key={currentGroup?.id || 'none'}
                open={subjectsModal.open}
                onCancel={closeSubjectsModal}
                onSubmit={handleAssignSubjects}
                title={subjectsModal.title}
                options={subjectsModal.options}
                loading={subjectsModal.loading}
                initialSelectedIds={subjectsModal.initialSelectedIds}
            />
            
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 12,
                }}
                >
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    {/* <Button
                    onClick={() => history.goBack()}
                    type="primary"
                    icon={<FontAwesomeIcon icon={solid('arrow-left')} />}
                    >
                    Înapoi
                    </Button> */}

                    <Typography.Title level={4} style={{ margin: 0 }}>
                    {studyPlan?.programName} — Plan {studyPlan?.planYear?.toString() + ' - ' + studyPlan?.endPlanYear?.toString()}
                    </Typography.Title>
                </div>

                {/* <Tooltip title="Adaugă grup de discipline">
                    <Link to={{ pathname: "/adaugare-grup/", state: { studyPlanId } }}>
                    <Button type="primary" icon={<PlusOutlined />}>
                        Adaugă grup de discipline
                    </Button>
                    </Link>
                </Tooltip> */}
            </div>

            <Table
                className={styles.usersTable}
                dataSource={data?.data || []}
                scroll={{ y: 'calc(100vh - 330px)'  }}
                sticky={true}
                pagination={{
                    total: data?.totalCount,
                    current: currentPage,
                    pageSize: data?.pageSize,
                    pageSizeOptions: ["10", "20", "50"],
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    showTotal: (total: number, range: [number, number]) => {
                        return <div>
                                <Tooltip title="Adaugă grup de discipline">
                                    {/* //TODO */}
                                    <Link to={{pathname: "/adaugare-grup/", state: {studyPlanId, studyPlanCycle}}}>
                                        <Button type="primary" icon={<PlusOutlined />}>
                                            Adaugă grup de discipline
                                        </Button>
                                    </Link>
                                </Tooltip>
                            </div>
                    },
                    hideOnSinglePage: false,
                    locale: { items_per_page: t('configuration.pagination')},
                    position: ['topRight']
                }}
                locale={{
                    emptyText: (
                        <span>
                            <h3>Nu există grupuri de discipline adăugate! Apasă butonul de mai jos pentru a adăuga un grup nou!</h3>
                            <Tooltip title="Adaugă grup de discipline">
                                {/* //TODO */}
                                <Link to={{pathname: "/adaugare-grup/", state: {studyPlanId, studyPlanCycle}}}>
                                    <Button type="primary" icon={<PlusOutlined />}>
                                        Adaugă grup de discipline
                                    </Button>
                                </Link>
                            </Tooltip>
                        </span>
                      )
                }}
                columns={columns}
                rowKey={record => record.id!}
                loading={isLoading}
                onChange={handleTableChange}
            />
        </Layout>
    </div>
}

export default DisciplineGroups;
